var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"sticky",rawName:"v-sticky",value:(_vm.stickyEnabled),expression:"stickyEnabled"}],staticClass:"competition-header",attrs:{"sticky-offset":"{top: 89, bottom: 0}","sticky-z-index":"10"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-809f6ae4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sportsbook/RegionRow.vue
// module id = lkeF
// module chunks = 0